import { PublicationServicePath } from "utils/constants";

export const publicationRequests = {
  // Imports the logged-in employee's publications by their ORCID; no body, the backend reads the employee from the session.
  importPublications: () => `${PublicationServicePath}publications/import`,

  // Publication profile of the logged-in employee (resolved from the session); the same URL serves GET and PUT.
  publicationProfileAuthorNames: () => `${PublicationServicePath}publication-profile/author-names`,
  publicationProfileOrcid: () => `${PublicationServicePath}publication-profile/orcid`,
  publicationProfileScopusId: () => `${PublicationServicePath}publication-profile/scopus-id`,
  publicationProfileWebOfScienceId: () => `${PublicationServicePath}publication-profile/web-of-science-id`,
};
